// Helpers for the public marketing landing (served at the bare apex,
// e.g. chitdesk.com / www.chitdesk.com).
//
// The signup + login flows run on the MASTER app host (chitos.<apex>) so the
// studio resolves its API to chitos-api.<apex> (see lib/orpc.ts). The landing
// therefore links cross-subdomain with absolute URLs rather than SPA <Link>s.

/**
 * True when the current host is the public marketing apex — a bare registrable
 * domain (e.g. `chitdesk.com`, 2 labels) or its `www.` alias. The ChitDesk
 * bundle is only ever served at such a host for chitdesk.com (vimalprakash.com's
 * apex points at a different Pages project), so "2-label host" unambiguously
 * means "the ChitDesk marketing apex".
 */
export function is_marketing_host(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host.endsWith('.localhost')) return false;
  const parts = host.split('.');
  return parts.length === 2 || parts[0] === 'www';
}

/**
 * Build an absolute URL to a path on the MASTER app host for the current apex.
 *
 *   chitdesk.com         → https://chitos.chitdesk.com/<path>
 *   www.chitdesk.com     → https://chitos.chitdesk.com/<path>
 *   chitos.chitdesk.com  → https://chitos.chitdesk.com/<path>
 *   localhost (dev)      → /<path>   (relative — same dev origin)
 */
export function master_app_url(path: string): string {
  const clean = '/' + path.replace(/^\/+/, '');
  if (typeof window === 'undefined') return clean;
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host.endsWith('.localhost')) return clean;
  const apex = host.split('.').slice(-2).join('.');
  return `${window.location.protocol}//chitos.${apex}${clean}`;
}
